<template>
  <div style="background: #eeeeee; height: 100vh">
    <div class="wrap">
      <van-sticky>
        <van-nav-bar title="申请记录" left-arrow @click-left="$router.go(-1)" />
      </van-sticky>
      <!-- 列表 -->
      <div class="recordList">
        <div class="recordItem" v-for="(item, index) in list" :key="index">
          <div class="itemLeft" style="width: 100%">
            <div
              class="itemMoney"
              style="display: flex; justify-content: space-between"
            >
              <div></div>
              <div style="text-align: right">
                <span v-show="item.status == 0" style="color: #00aeff"
                  >待审核</span
                >
                <span v-show="item.status == 1" style="color: #3b6bfb"
                  >已通过</span
                >
                <span v-show="item.status == 2" style="color: red">已拒绝</span>
              </div>
            </div>
              <div class="itemMoney">
                申请级别:
                <span>{{ item.rank_name }}</span>
              </div>
              <div class="itemMoney" v-if="item.status == 2">
                拒绝原因:
                <span>{{ item.refuse }}</span>
              </div>
              <div class="itemMoney">
                <span>申请时间:{{ item.create_time }}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rankRecord } from "@/api/personal";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      rankRecord().then((resp) => {
        this.list = resp;
      });
    },
  },
};
</script>
<style lang='less' scoped>
.wrap {
  height: 100%;
  background: #eeeeee;
  .walletTop {
    width: 357px;
    height: 162.5px;
    background: url("../../assets/imgs/personal/walletBg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    margin: 7.5px auto 8.5px;
    padding: 42px 0 0 19.5px;
    color: #fff;
    font-size: 13px;
    position: relative;
    box-sizing: border-box;
    .topTitler {
      position: absolute;
      right: 5px;
      top: 50px;
      background: #02ac36;
      border-radius: 11.5px 0 0 11.5px;
      padding: 5.5px 16px;
    }
    .topTitle {
      position: absolute;
      right: 5px;
      top: 15.5px;
      background: #02ac36;
      border-radius: 11.5px 0 0 11.5px;
      padding: 5.5px 16px;
    }
    .topNum {
      div {
        &:last-child {
          font-size: 25px;
          margin-top: 17px;
        }
      }
    }
  }
  .walletTitle {
    color: #343434;
    font-size: 15px;
    margin: 0 0 8.5px 18px;
  }
  .recordList {
    width: 345px;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 13px;
    margin: 0 auto;
    .recordItem {
      background: #fff;
      border-radius: 6px;
      color: #666666;
      padding: 14.5px 13px 12.5px;
      font-size: 13px;
      .itemtype {
        color: #343434;
      }
      .itemMoney {
        margin-top: 11.5px;
        span {
          color: #343434;
        }
      }
      .itemRight {
        text-align: right;
        .itemStatus {
          font-size: 16px;
        }
        .itemTime {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>